import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading = new BehaviorSubject<boolean>(false);
  private totalRequests = 0;

  constructor() {}

  showLoader() {
    this.totalRequests++;
    if (this.totalRequests > 0) {
      this.isLoading.next(true);
    }
  }

  hideLoader() {
    this.totalRequests--;
    if (this.totalRequests == 0) {
      this.isLoading.next(false);
    }
  }
}
